module.exports = __webpack_public_path__ + "images/04030e66f23054886c6f1d6e706f8ab1.svg";